import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {GlobalConstantsComponent} from '../../shared/global-constants/global-constants.component';
import {Router} from '@angular/router';
import {AuthenticationService} from '../authentication.service';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})

/**
 * Purpose : Send informations in DB to know where our users go when redirected
 * Installé dans : - visa start
 *                 - Accomodation
 *
 * updates : 16.07.2021
 * Last update : 17.01.2022 - debug unlog
 *
 */

export class RedirectionTrackingService {

  private APIURL = GlobalConstantsComponent.apiURL;
  isBrowser;

  constructor(
    private http: HttpClient,
    private router: Router,
    private authenticationService: AuthenticationService,
    @Inject(PLATFORM_ID) private platformId
    ) {
      this.isBrowser = isPlatformBrowser(platformId);
  }

  /**
   * @TODO : SUPPRIMER LE PARTNERREF DES QUE LE PARTENAIRE A ETE INSTALLE DANS LES LOGEMENTS
   *
   */

  sendRedirectLinkInformations({partner, toPage, partnerRef}) {
    if (this.isBrowser){
      localStorage.setItem('redirect', toPage);
      this.redirectUser();
      const fromPage = this.router.url;
      if (this.authenticationService.currentUserValue) {
        return this.http.post(`${this.APIURL}redirectionTrackingLink/sendInformation`, {partner, fromPage, toPage, partnerRef}) as any;
      }
      return null;
    }
  }

  redirectUser() {
    window.open(this.router.serializeUrl(this.router.createUrlTree(['/redirect'])), '_blank');
  }

  getUrl() {
    return this.http.get(`${this.APIURL}redirectionTrackingLink/getUrl`) as any;
  }

}
